import { render, staticRenderFns } from "./Tender.vue?vue&type=template&id=ace087e2&scoped=true"
import script from "./Tender.vue?vue&type=script&lang=js"
export * from "./Tender.vue?vue&type=script&lang=js"
import style0 from "./Tender.vue?vue&type=style&index=0&id=ace087e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace087e2",
  null
  
)

export default component.exports